<script type="text/ecmascript-6">

import { h } from 'vue'
export default {
  name: 'FouGroup',
  props: {
    bottom: {
      type: String,
      default: null
    },
    border: {
      type: String,
      default: null
    },
    element: {
      type: String,
      default: 'div'
    }
  },

  data () {
    return {
      attrs: [
        'bottom',
        'border'
      ],
      variations: {
        bottom: [
          'medium',
          'large'
        ],
        border: [
          'top',
          'bottom'
        ]
      }
    }
  },

  methods: {
    modifiers () {
      const modifiers = []
      this.attrs.forEach(a => {
        if (this[a]) {
          if (this.variations[a].indexOf(this[a]) !== -1) {
            modifiers.push(`mt-group--${a}-${this[a]}`)
          }
        }
      })
      return modifiers
    },
    getClass (classes) {
      return classes.join(' ')
    }
  },

  render: function () {
    return h(
      this.element, {
        class: this.getClass([
          'mt-group',
          ...this.modifiers()
        ])
      },
      this.$slots.default?.()
    )
  }
}
</script>
